/**
 * /tenants/$slug — tenant overview landing.
 *
 * Thin shim: the layout route has already prefetched the tenant
 * header (context.tenant). This loader also prefetches the
 * overview rollup so the page renders instantly with no spinner.
 */

import { TenantHomePage } from "@/features/managed-administration/pages/customer-home-page";
import { canReadTenantHome } from "@/features/managed-administration/access-presentation";
import { createFileRoute } from "@tanstack/react-router";
import { fetchTenantOverview } from "@/features/tenants/queries";
import { queryKeys } from "@/lib/query-keys";

export const Route = createFileRoute("/_authed/tenants/$slug/")({
  loader: async ({ context }) => {
    if (!canReadTenantHome(context.authority)) return;
    const tenantID = context.tenant.id;
    await context.queryClient.ensureQueryData({
      queryKey: queryKeys.tenants.overview(tenantID),
      queryFn: () => fetchTenantOverview(tenantID),
    });
  },
  component: TenantHomePage,
});
